import React from 'react';

import { faPlus } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from '@/components/ui/button';
import { useReviewRequestDialog } from '../hooks';

const ReviewRequestButton = () => {
  const { handleOpenDialog } = useReviewRequestDialog();

  return (
    <Button onClick={handleOpenDialog}>
      <FontAwesomeIcon icon={faPlus} />
      New Review Request
    </Button>
  );
};

export default ReviewRequestButton;
